import React, { useEffect, useRef, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { obtenirUrlControleur } from '../utils/urlUtils';
import fetchUtil from '../utils/fetch';

const ConfirmerCourrielContainer = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const token = searchParams.get('token') || '';

    const [statut, setStatut] = useState('en_cours');
    const appelEnCours = useRef(false);

    useEffect(() => {
        if (!token) {
            setStatut('erreur');
            return;
        }

        // Empêche le double appel (React StrictMode ou re-render)
        if (appelEnCours.current) return;
        appelEnCours.current = true;

        const apiBase = obtenirUrlControleur('auth');
        fetchUtil(`${apiBase}/api/auth/confirmer-courriel?token=${encodeURIComponent(token)}`)
            .then(() => setStatut('succes'))
            .catch(() => setStatut('erreur'));
    }, [token]);

    return (
        <div style={{ fontFamily: 'Arial, sans-serif', maxWidth: '600px', margin: '80px auto', padding: '20px', textAlign: 'center' }}>
            {statut === 'en_cours' && (
                <>
                    <h2 style={{ color: '#2c3e50' }}>Confirmation en cours…</h2>
                    <p>Veuillez patienter pendant la vérification de votre adresse courriel.</p>
                </>
            )}
            {statut === 'succes' && (
                <>
                    <h2 style={{ color: '#27ae60' }}>✅ Adresse courriel confirmée !</h2>
                    <p>Votre compte <strong>APSAM</strong> est maintenant activé. Vous pouvez vous connecter.</p>
                    <button
                        onClick={() => navigate('/')}
                        style={{ background: '#007bff', color: 'white', padding: '12px 28px', border: 'none', borderRadius: '6px', fontSize: '16px', cursor: 'pointer', marginTop: '20px' }}>
                        Se connecter
                    </button>
                </>
            )}
            {statut === 'erreur' && (
                <>
                    <h2 style={{ color: '#e74c3c' }}>❌ Lien invalide ou expiré</h2>
                    <p>Ce lien de confirmation est invalide, a déjà été utilisé, ou a expiré (72h).</p>
                    <p style={{ fontSize: '14px', color: '#666' }}>
                        Essayez de vous inscrire à nouveau pour recevoir un nouveau lien.
                    </p>
                    <button
                        onClick={() => navigate('/')}
                        style={{ background: '#6c757d', color: 'white', padding: '12px 28px', border: 'none', borderRadius: '6px', fontSize: '16px', cursor: 'pointer', marginTop: '20px' }}>
                        Retour à l'accueil
                    </button>
                </>
            )}
        </div>
    );
};

export default ConfirmerCourrielContainer;
